import React, { useMemo } from 'react';
import './CalorieDisplay.css';

function CalorieDisplay({ baseRecipe, quantity }) {
  // Calorie values per unit for each ingredient (approximate values)
  const calorieData = {
    flour: 455, // calories per cup of bread flour
    milk: 103,   // calories per cup of whole milk
    sugar: 774,  // calories per cup of granulated sugar
    egg: 72,     // calories per large egg
    butter: 102, // calories per tablespoon
    yeast: 20,   // calories per tablespoon
    salt: 0      // negligible calories
  };

  // Calculate total and per-pav calories
  const { totalCalories, caloriesPerPav } = useMemo(() => {
    const multiplier = quantity / 6; // Base recipe is for 6 pavs
    
    // Calculate calories for each ingredient in the entire recipe
    const flourCalories = baseRecipe.flour * multiplier * calorieData.flour;
    const milkCalories = baseRecipe.milk * multiplier * calorieData.milk;
    const sugarCalories = baseRecipe.sugar * multiplier * calorieData.sugar;
    const eggCalories = baseRecipe.egg * multiplier * calorieData.egg;
    const butterCalories = baseRecipe.butter * multiplier * calorieData.butter;
    const yeastCalories = baseRecipe.yeast * multiplier * calorieData.yeast;
    
    // Sum of all ingredients
    const total = Math.round(
      flourCalories + 
      milkCalories + 
      sugarCalories + 
      eggCalories + 
      butterCalories + 
      yeastCalories
    );
    
    // Calculate per-pav calories
    const perPav = Math.round(total / quantity);
    
    return { totalCalories: total, caloriesPerPav: perPav };
  }, [baseRecipe, quantity, calorieData]);

  return (
    <section className="calorie-display">
      <h2>Calorie Information</h2>
      <div className="calorie-info">
        <div className="calorie-card">
          <h3>Per Pav</h3>
          <div className="calorie-value">{caloriesPerPav}</div>
          <div className="calorie-label">calories</div>
        </div>
        <div className="calorie-card">
          <h3>Total Recipe</h3>
          <div className="calorie-value">{totalCalories}</div>
          <div className="calorie-label">calories</div>
        </div>
      </div>
      <p className="calorie-note">
        * Calorie values are approximate and calculated based on standard nutritional data.
      </p>
    </section>
  );
}

export default CalorieDisplay;